/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratorapplyallfunds4Inputs */

const en_settings_collaborators_invitecollaboratorapplyallfunds4 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratorapplyallfunds4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply to all funds`)
};

/**
* | output |
* | --- |
* | "Apply to all funds" |
*
* @param {Settings_Collaborators_Invitecollaboratorapplyallfunds4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratorapplyallfunds4 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratorapplyallfunds4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratorapplyallfunds4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratorapplyallfunds4(inputs)
});
export { settings_collaborators_invitecollaboratorapplyallfunds4 as "settings_collaborators_inviteCollaboratorApplyAllFunds" }